"use strict";

module.exports = function (accumulator, order, product, component) {
  var numToAdd = 0;

  if (component.quantity > 5) {
    numToAdd = component.num_to_add == null ? 4 : component.num_to_add;
  }

  var addition = parseInt(component.quantity, 10) + parseInt(numToAdd, 10);
  var actualNumber = 0 + addition;
  var pricePer = component.ink_color === 'Black' ? 0 : 0.25;
  var price = actualNumber * pricePer;
  return accumulator + price;
};